
let data_product = [
  {
    id:1,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price:50.00,
    old_price:80.50,
  },
  {id:2,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price:85.00,
    old_price:120.50,
  },
  {id:3,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price:60.00,
    old_price:100.50,
  },
  {id:4,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image: "https://m.advanceshipping.ru/img/vagon/kritii-vagon.png",
    new_price:100.00,
    old_price:150.00,
  },
];

export default data_product;
